<script>
export default {
  components: {},
  inheritAttrs: false,
  props: {
    source: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      required: true,
    },
  },
  computed: {
    // Gets a CSS module class, e.g. iconCustomLogo
    // customIconClass() {
    //   return this.$style[camelCase('icon-custom-' + this.name)]
    // },
  },
}
</script>

<template>
  <div>
    <p>Icons</p>
  </div>
</template>
